import React, { createContext, useReducer } from 'react';
import { BrowserRouter as Router, Route, Switch , BrowserRouter} from "react-router-dom";
import Login from "./components/Login/Login";
import EnvsPage from './components/EnvsPage/EnvsPage';
import { initialState, reducer } from "./store/reducer";
import IP_search from './components/IP_search/IP_search';
import AppLayout from './components/AppLayout/AppLayout';
import Debugger from './components/Debugger/Debugger';
import Cookies from 'universal-cookie';
import Modal from "react-modal";
import Releases from './components/Releases/Releases';
import ProgressBar from './components/ProgressBar/ProgressBar';
import Services from './components/Services/Services';
import Service from './components/Service/Service';
import Redis from './components/Redis/Redis';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { createBrowserHistory } from 'history';
import Audits from './components/Audits/Audits';
const cookies = new Cookies();
export const AuthContext = createContext();
Modal.setAppElement("#root");
const history = createBrowserHistory();

Sentry.init({
    dsn: "https://8ae93ce888f84841837840aae4dcdd5d@o120871.ingest.sentry.io/4504116207550464",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    release: process.env.REACT_APP_COMMIT_SHA,
    beforeSend: (event) => {
        try {
            event.extra = event.extra || {};
            event.tags = event.tags || {};
            event.environment = process.env.REACT_APP_STAGE == "staging" ? "STAGING" : "PROD";
        }
        catch (err) { 
            console.log("error")
        }
        return event;
    },
    integrations: [
      new BrowserTracing({
        tracingOrigins: ["localhost", "axiom.workiz.com", "axiom-staging.workiz.com", /^\//],
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
    ],
})
Sentry.setUser({ login: cookies.get("login"), name: cookies.get("name") });





function App() {

  const [state, dispatch] = useReducer(reducer, initialState);
  const UserContext = createContext()

  return (
    

    <AuthContext.Provider
      value={{
        state,
        dispatch
      }}
    >

    <BrowserRouter>
      
    
       
        {cookies.get("code")==undefined ?  (
           <Router>
          <Route path='/' component={Login}/>
          {/* <Route path="/login" component={Login}/> */}
         </Router>

        )
        :(
          <Router>
          <Route path='/' component={AppLayout}/>
        <Switch>
        <Route path="/ip" component={IP_search}/>
        <Route path="/login" component={Login}/>
        <Route path="/google" component={Login}/>
        <Route path="/createEnv" component={EnvsPage}/>
        <Route path="/debugger" component={Debugger}/>
        <Route path="/releases" component={Releases}/>
        <Route path="p" component={ProgressBar} />
        <Route path="/services" component={Services}/>
        <Route path="/service" component={Service}/>
        <Route path="/audits" component={Audits} />
        <Route path="/redis" component={Redis} />
        <Route path="/" component={EnvsPage}/>
        </Switch>
       </Router>

          
        )}
     
        
     
    </BrowserRouter>

     </AuthContext.Provider>
  );
}

export default App;
